export default () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return localStorage.getItem('selectedMallSlug')
  }
  return undefined
}
